/**
 * Gestion des messages FR de la gestion des crédits
 */

module.exports = {

    credits: 'crédit | crédit | crédits',
    counter: '<span class="counter">0</span> crédit | <span class="counter">1</span> crédit | <span class="counter">{ count }</span> crédits',
    from: 'À partir de',

    taskConfigurations: {
        groups: {
            button: {
                label: 'Gérer les groupes de configuration'
            }
        },
        title: 'Coût par tâche',
        fields: {
            task: 'Tâche',
            credits: 'Crédits'
        }
    },

    purchase: {
        title: 'Abonnements et crédits',
        description: 'Souscrire ou modifier votre abonnement / vos crédits',

        monthly: {
            metaTitle: 'Abonnements - Souscrire',
            tabLabel: 'Abonnement',
            paymentFrequency: {
                monthly: 'Mensuel',
                yearly: 'Annuel'
            },
            product: {
                credits: '0 crédit | 1 crédit | { count } crédits',
                subscribeButton: {
                    label: 'Souscrire à l\'abonnement'
                },
                affiliationCode: {
                    label: 'Code d\'affiliation'
                },
                unsubscribeButton: {
                    label: 'Se désabonner'
                }
            },

            unsubscribeModal: {
                title: 'Se désabonner',
                description: 'Pour quelle raison souhaitez-vous arrêter votre abonnement ?',
                form: {
                    error: 'Une erreur s\'est produit lors de votre désabonnement.',
                    fields: {
                        otherReason: 'Préciser la raison'
                    },
                    button: {
                       submit: {
                           label: 'Me désabonner'
                       }
                    }
                }
            },

            selectConserveNetworksModal: {
                title: 'Réseau à conserver | Réseau à conserver | Réseaux à conserver',
                form: {
                    error: 'Une erreur s\'est produite pendant l\'enregistrement.'
                }
            },

            endedAt: 'Fin de l\'abonnement le { date }.'
        },

        unique: {
            metaTitle: 'Crédits',
            tabLabel: 'Crédits'
        },

        loading: {
            error: {
                countries: 'Une erreur s\'est produite pendant le chargement des données.',
                taskConfiguration: 'Une erreur s\'est produite pendant le chargement des données.',
                creditPacks: 'Une erreur s\'est produite pendant le chargement de la liste des produits.',
                currentSubscription: 'Une erreur s\'est produite pendant le chargement de votre abonnement.',
                cart: 'Une erreur s\'est produite pendant l\'initialisation du panier.',
                empty: 'Aucun produit n\'a été trouvé.'
            }
        },

        cart: {
            title: 'Mon panier',
            amountWithoutTax: 'Sous total H.T.',
            tax: 'TVA ({ percent }%)',
            amountWithTax: 'Total T.T.C.',
            reductionWithoutTax: 'Réduction H.T.'
        },

        payment: {
            title: 'Paiement',
            methods: {
                creditCard: 'Carte bancaire',
                sepa: 'Virement SEPA',
            },
            error: 'Une erreur s\'est produite pendant le processus de paiement.',
            fields: {
                method: 'Méthode de paiement',
                creditCard: {
                    ownerName: 'Nom du titulaire de la carte',
                    number: 'Numéro de carte',
                    expiry: 'Date d\'expiration',
                    cvc: 'Code de validation (CVV ou CVC)'
                },
                sepa: {
                    ownerName: 'Nom du titulaire',
                    email: 'Adresse email',
                    iban: 'IBAN'
                }
            },
            fieldset: {
                society: 'Informations de facturation'
            },
            validation: {
                owner: {
                    required: 'Le nom est requis.',
                    min: 'Le nom doit avoir au moins { min } caractères.',
                    max: 'Le nom doit avoir au plus { max } caractères.'
                },
                email: {
                    email: 'L\'adresse email est incorrecte.'
                }
            },
            waitingValidation: 'Votre paiement est en attente de validation, vous serez notifié lorsqu\'il aura été validé.',
            cvc: {
                altLabel: 'Cliquer pour en savoir plus sur le code de validation d\'une carte bancaire.'
            },
            sepa: {
                disclaimer: 'En fournissant votre IBAN et en confirmant ce paiement, vous autorisez { applicationName } à envoyer des instructions à votre banque pour débiter votre compte.'
            },
            submit: {
                label: 'Valider ma commande'
            }
        }

    },

    paymentInformations: {
        form: {
            error: 'Une erreur s\'est produite pendant le traitement de vos informations de paiement.'
        }
    }

};
